export const ROLE_ADMINISTRATOR = 'bm_administrator';
export const ROLE_MANAGER = 'bm_manager';
